export const getFileExtension = (fileName: string): string => {
  var a = fileName.split(".");
  if (a.length === 1 || (a[0] === "" && a.length === 2)) {
    return "";
  }
  return a.pop() || "";
};

export const errorString = (
  err: Error | string | { message: string },
  fallbackErrorMessage?: string
): string => {
  if (typeof err === "string") {
    return err;
  }

  if (err instanceof Error) {
    return err.message;
  }

  if (typeof err === "object" && err.message) {
    return err.message;
  }

  return fallbackErrorMessage || "something went wrong";
};
